import React from 'react';
import Translate from '../../../src/components/Translate/Translate';
import classnames from '../../../src/helpers/classnames';

export default function DropFileHereMessage(props: {
    onClick: React.MouseEventHandler,
    disabled?: boolean,
}) {
    return <Translate
            tag="div"
            message="OrderForm:FilesList.drag-and-drop-files-here-or-click-to-choose"
            className={classnames('order__files-list__drop-here-message', {
                'order__files-list__drop-here-message--disabled': props.disabled
            })}
            onClick={props.disabled ? undefined : props.onClick}
            tabIndex={0}
    />;
}
